import React, { useState, useEffect } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Box
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import { SIZES } from "../../../common/constants/commonConstants.js";
import { NOTES_TABLE_COLUMNS } from "../../../common/constants/agentModule/statusConstants.js";
import { getAgentNotes } from "../../../services/agentModule/agentInfoServices.js";

const AgentNotes = () => {
	const [notes, setNotes] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const agentGUID = localStorage.getItem("userguid");

	useEffect(() => {
		fetchNotes();
	}, []);

	const fetchNotes = async () => {
		setIsLoading(true);
		try {
			const data = await getAgentNotes({ agentGUID });
			setNotes(data || []);
		} catch (error) {
			console.error("Error fetching notes:", error);
		} finally {
			setIsLoading(false);
		}
	};

	const formatDate = (isoDate) => {
		const date = new Date(isoDate);
		return date.toLocaleString();
	};

	return (
		<>
			{isLoading ? (
				<>
					<Box sx={{ width: '100%' }}>
						<LinearProgress />
					</Box>
				</>
			) : (
				<>
					<TableContainer>
						<Table size={SIZES.SMALL}>
							<TableHead>
								<TableRow>
									{NOTES_TABLE_COLUMNS.map((column) => (
										<TableCell
											key={column.id}
											sx={{
												width:
													column.id === NOTES_TABLE_COLUMNS.FIRSTNAME ? 150 :
													column.id === NOTES_TABLE_COLUMNS.LASTNAME ? 150 :
													column.id === NOTES_TABLE_COLUMNS.NOTE ? 250 :
													column.id === NOTES_TABLE_COLUMNS.DATE ? 100 : 200,
											}}
										>
											{column.label}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{notes.length === 0 ? (
									<TableRow>
										<TableCell colSpan={4} align="center">
											No Notes Found
										</TableCell>
									</TableRow>
								) : (
									notes.map((notes, index) => (
										<TableRow key={index}>
											<TableCell>{notes.lastname}</TableCell>
											<TableCell>{notes.firstname}</TableCell>
											<TableCell>{notes.notesvalue}</TableCell>
											<TableCell>{formatDate(notes.createdAt)}</TableCell>
										</TableRow>
									))
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</>
			)}
		</>
	);
};

export default AgentNotes;